var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_2008_5283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9295 24C19.7565 24 22.8589 22.2091 22.8589 20C22.8589 17.7909 19.7565 16 15.9295 16C12.1024 16 9 17.7909 9 20C9 22.2091 12.1024 24 15.9295 24Z",
    fill: "#E6F8E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9297 19.9974L19.1583 15.8758C18.1708 15.4397 17.0786 15.1974 15.9297 15.1974C14.7808 15.1974 13.6887 15.4397 12.7012 15.8758L15.9297 19.9974Z",
    fill: "#4DC84D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9297 16C18.1388 16 19.9297 14.2091 19.9297 12C19.9297 9.79086 18.1388 8 15.9297 8C13.7205 8 11.9297 9.79086 11.9297 12C11.9297 14.2091 13.7205 16 15.9297 16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2008_5283",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14AE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8546"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.b6151e5ccaf851e7b928e8d25060a8f2.svg";
export { ForwardRef as ReactComponent };